import React from 'react';
import { ChevronUpIcon, ChevronDownIcon } from '@domain-group/fe-co-icon';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesListingCardPaginator = _ref => {
  var _ref$showButton = _ref.showButton,
    showButton = _ref$showButton === void 0 ? false : _ref$showButton,
    _ref$allListingsShown = _ref.allListingsShown,
    allListingsShown = _ref$allListingsShown === void 0 ? false : _ref$allListingsShown,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$onShowAll = _ref.onShowAll,
    onShowAll = _ref$onShowAll === void 0 ? () => {} : _ref$onShowAll,
    _ref$onShowLess = _ref.onShowLess,
    onShowLess = _ref$onShowLess === void 0 ? () => {} : _ref$onShowLess,
    className = _ref.className;
  return ___EmotionJSX("div", {
    className: className
  }, showButton && (allListingsShown ? ___EmotionJSX(Button, {
    appearance: "outline",
    size: "small",
    icon: ___EmotionJSX(ChevronUpIcon, {
      size: "small"
    }),
    iconPosition: "right",
    onClick: onShowLess
  }, "Show less") : ___EmotionJSX(Button, {
    appearance: "outline",
    size: "small",
    icon: ___EmotionJSX(ChevronDownIcon, {
      size: "small"
    }),
    iconPosition: "right",
    disabled: loading,
    onClick: onShowAll
  }, "Show more")));
};
export default AllhomesListingCardPaginator;